import { iUserData } from '../api/SuklUsersApi'

export const mapSlugToStaticUserData = (userData: iUserData): { [slug: string]: any } => ({
  'hlaseni-ceny-puvodce': {
    'submitter': {
      'name': userData.jmena,
      'surname': userData.prijmeni,
    },
  },
  'oznameni-o-zahajeni-preruseni-ukonceni-zasilkoveho-vydeje': {
    'osobaOdpovedna': {
      'jmeno': userData.jmena,
      'prijmeni': userData.prijmeni,
      'adresa': {
        'ulice': userData.adresa.ulice,
        'cisloDomu': userData.adresa.cisloPopisne, // + userData.adresa.cisloOrientacni // TODO format cisloOrientacni
        'obec': userData.adresa.obec,
        'psc': userData.adresa.psc,
        'stat': 'CZE'
      },
    },
  },
  'oznameni-o-pouziti-nlp': {
    'lekar': {
      'jmeno': userData.jmena,
      'prijmeni': userData.prijmeni,
    },
  },
  'zadost-o-souhlas-s-dovozem-leciveho-pripravku-ze-treti-zeme': {
    'distributor': {
      'kontaktniOsoba': {
        'jmeno': userData.jmena,
        'prijmeni': userData.prijmeni, // TODO urcite????
      },
    },
  },
  'kontaktni-formular': {
    'jmeno': userData.jmena + ' ' + userData.prijmeni
  }
})

export const mapSlugToDynamicUserData = (userData: iUserData): { [slug: string]: any } => ({
  //platby
  'e3':{
    'poverenaOsoba': {
      'jmeno': userData.jmena,
      'prijmeni': userData.prijmeni,
    },
    'adresa': {
      'ulice': userData.adresa.ulice,
      'cisloDomu': userData.adresa.cisloPopisne,//+ userData.adresa.cisloOrientacni// TODO  format cisloOrientacni
      'obec': userData.adresa.obec,
      'psc': userData.adresa.psc,
      'stat': 'CZ'
    }
  },
//specificky-lecebny-program
  'osoba2': {
    'predkladatel.fyzicka': {
      'jmeno': userData.jmena,
      'prijmeni': userData.prijmeni,
      'adresa': {
        'ulice': userData.adresa.ulice,
        'cisloDomu': userData.adresa.cisloPopisne,//+ userData.adresa.cisloOrientacni// TODO  format cisloOrientacni
        'obec': userData.adresa.obec,
        'psc': userData.adresa.psc,
        'stat': 'CZE'
      }
    },
    'predkladatel.pravnicka.kontaktniOsoba': {
      'jmeno': userData.jmena,
      'prijmeni': userData.prijmeni,
    },
  },

//zadost-o-poskytnuti-informace
  'subject': {
    'name': userData.jmena,
    'surname': userData.prijmeni,
    'address': userData.adresa.ulice + ' ' + userData.adresa.cisloPopisne + ', ' + userData.adresa.obec + ' ' + userData.adresa.psc
  },

  //hlaseni-podezreni-na-vyskyt-padelku-lp
  //hlaseni-podezreni-na-zavadu-lp
  'zavada': {
    'kontaktniOsoba': {
      'jmeno': userData.jmena,
      'prijmeni': userData.prijmeni,
    },
    'hlasitelPacient': {
      'jmeno': userData.jmena,
      'prijmeni': userData.prijmeni,
      'adresa': {
        'ulice': userData.adresa.ulice,
        'cisloPopisne': userData.adresa.cisloPopisne,
        'cisloOrientacni': userData.adresa.cisloOrientacni,
        'obec': userData.adresa.obec,
        'psc': userData.adresa.psc,
      }
    }
  },

  // zadost-o-umozneni-uvedeni-cizojazycne-sarze-leciveho-pripravku-do-obehu
  'cizojazycnaSarze': {
    'kontaktniOsoba': {
      'jmeno': userData.jmena,
      'prijmeni': userData.prijmeni,
    },
    'fo': {
      'kontaktniOsoba': {
        'jmeno': userData.jmena,
        'prijmeni': userData.prijmeni,
      },
      'adresa': {
        'ulice': userData.adresa.ulice,
        'cisloPopisne': userData.adresa.cisloPopisne,
        'cisloOrientacni': userData.adresa.cisloOrientacni,
        'obec': userData.adresa.obec,
        'psc': userData.adresa.psc,
      },
    }
  }
})
